import React, { FC } from 'react';
import styled from 'styled-components';
import { Icons } from '../../../../../assets';
import { flexMixin, textMixin } from '../../../../../styles/mixins';
import { colors } from '../../../../../styles';

interface IDiffInfo {
    diff: number;
}

export const DiffRevenueInfo: FC<IDiffInfo> = ({ diff }) => {
    return (
        <Wrapper>
            <DiffBox $isdiff={diff > 0}>
                <TextWrap>
                    {diff > 0 ? (
                        <img src={Icons.ArrowUpWhite} alt="Proga.pro arrow" />
                    ) : (
                        <img
                            src={Icons.ArrowDownWhite}
                            alt="Proga.pro arrow down"
                        />
                    )}
                    {`${diff ? diff.toFixed(2) : 0} %`}
                </TextWrap>
            </DiffBox>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    min-width: 110px;
    ${flexMixin('row', 'center', 'center')};
`;

const DiffBox = styled.div<{
    $isdiff: boolean;
}>`
    padding: 3px 10px;
    border-radius: 5px;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 700,
    })};
    width: 100%;
    color: ${colors.cleanWhite};
    ${flexMixin('row', 'center', 'center')};
    background-color: ${({ $isdiff }) => ($isdiff ? '#3BCA1E' : '#FF3B30')};
`;
const TextWrap = styled.div`
    ${flexMixin('row', 'space-between', 'center')};
    width: 100%;
`;
